import React, { useState, useEffect } from "react";
import {
  Col,
  Tag,
  Table,
  Modal,
  message,
  Button,
  Form,
  DatePicker,
  Input,
  Upload,
  Image,
  Empty,
  Select,
  Row,
  Cascader,
} from "antd";
import {
  PlusOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;
import InspectionApi from "@api/inspectionnew";
import stationApi from "@api/station";
import DepartmentApi from "@api/department";
import { connect } from "react-redux";
import moment from "moment";
import {
  getStationData,
  defectStatus,
  defectStatusColor,
  instructStatus,
  toolMouseTip,
} from "@utils/common";
import AddModel from "./add";
import InstructAdd from "./InstructAdd";
import WorkAdd from "./WorkAdd";
import "./index.scss";
import "../style.scss";

const StatusData = ["待处理", "处理中", "完成", "关闭"];
const colorStatus = ["#FF3819", "#2db7f5", "#87d068", "#BDBDBD"];

const OrderCom = (props) => {
  const [form] = Form.useForm();
  const [recordingForm] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [loadBtn, setLoadBtn] = useState(false);
  const [data, setData] = useState([]); // 表格数据
  const [editVisible, setEditVisible] = useState(false);
  const [editTitle] = useState("新增缺陷单");
  const [rowParams, setRowParams] = useState();
  const [checkacceptVisible, setCheckacceptVisible] = useState(false);
  const [rateTionModel, setRateTionModel] = useState(false);
  const [modifyId, setModifyId] = useState();
  const [detailModelVisible, setDetailModelVisible] = useState(false);
  const [detail, setDetail] = useState({});
  const [relationDefectsLs, setRelationDefectsLs] = useState([]);
  const [selectionType, setSelectionType] = useState("checkbox");
  const [defectDetailImgVisibel, setDefectDetailImgVisibel] = useState(false);
  const [recordImageUrls, setRecordImageUrls] = useState([]);
  const [recordDefectId, setRecordDefectId] = useState();
  const [recordModal, setRecordModal] = useState(false);
  const [detailSourceImgsVisi, setDetailSourceImgsVisi] = useState([]);
  const [instructAddVisi, setInstructAddVisi] = useState(false);
  const [instructAddRowParams, setInstructAddRowParams] = useState();
  const [workAddVisi, setWorkAddVisi] = useState(false);
  const [workAddRowParams, setWorkAddRowParams] = useState(false);
  const [defectslevel, setDefectslevel] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [personParams, setPersonParams] = useState({
    stationId: 0,
    deptId: 0,
    containDeptHeaders: 1,
  });
  const [total, setTotal] = useState(0);
  // 关联缺陷单搜索参数
  const [relationSearchParams, setRelationSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [relationTotal, setRelationTotal] = useState(0); // 关联列表总数
  const [ids, setIds] = useState([]); // 关联缺陷单的ids
  const [relationId, setRelationId] = useState(); // 当前关联的id
  const [stationData, setStationData] = useState([]);
  const [deptList, setDeptList] = useState([]);
  const [personList, setPersonList] = useState([]);

  useEffect(() => {
    getStationList();
    getDefectLevel();
    getDept();
  }, []);

  useEffect(() => {
    getListByPages();
  }, [searchParams]);

  useEffect(() => {
    if (personParams.stationId && personParams.deptId) {
      getPersonList();
    }
  }, [personParams]);

  const getDefectLevel = () => {
    // 缺陷等级列表
    InspectionApi.defectLevelLs({ pageNum: 1, pageSize: 10 }).then((res) => {
      if (res.status !== "0") return;
      if (res.data && res.data.length > 0) {
        setDefectslevel(res.data);
      } else {
        setDefectslevel([]);
      }
    });
  };

  // 获取厂站列表
  const getStationList = async () => {
    const data = getStationData(
      props.userInfo.stationIds ? props.userInfo.stationIds : "-1",
      props.userInfo.stationAliasName,
    );
    setStationData(data);
  };

  // 获取部门列表
  const getDept = async () => {
    const res = await DepartmentApi.getDeptForTree({});
    if (!res.status) return;
    setDeptList(res.data);
  };

  // 获取部门负责人
  const getPersonList = () => {
    searchForm.setFieldsValue({ deptLeaderId: null });
    DepartmentApi.getDeptHeadersByDeptId(personParams).then((res) => {
      if (res.status !== "0") return;
      setPersonList(res.data);
    });
  };

  const getListByPages = () => {
    setLoading(true);
    InspectionApi.defectQuery({
      ...searchParams,
      status: searchParams.status * 1,
    }).then((res) => {
      setLoading(false);
      if (res.status == 0 && res.data) {
        setData(res.data.data || []);
        setTotal(res.data.total);
      }
    });
  };

  const changeSearchStation = (e) => {
    stationApi.getDeviceByStationId({ stationId: e ? e : 0 }).then((res) => {
      if (res.status === "0") {
        setDeviceList(res.data);
      }
    });
    let params = personParams;
    params.stationId = e ? e : 0;
    setPersonParams({
      ...params,
    });
  };

  // 切换部门
  const changeDept = (e) => {
    if (!e) return;
    let params = personParams;
    params.deptId = e[e.length - 1] - 0;
    setPersonParams({
      ...params,
    });
  };

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const handleTableChange1 = (pagination) => {
    let params = {
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setRelationSearchParams(params);
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    if (paramsObj.discoveryTime) {
      paramsObj.discoveryTimeBegin = moment(
        paramsObj.discoveryTime[0]._d,
      ).format("YYYY-MM-DD HH:mm:ss");
      paramsObj.discoveryTimeEnd = moment(paramsObj.discoveryTime[1]._d).format(
        "YYYY-MM-DD HH:mm:ss",
      );
    }
    delete paramsObj.discoveryTime;
    paramsObj.deviceRelevancyId = paramsObj.deviceRelevancyId
      ? paramsObj.deviceRelevancyId[paramsObj.deviceRelevancyId.length - 1]
      : "";
    paramsObj.deptId = paramsObj.deptId
      ? paramsObj.deptId[paramsObj.deptId.length - 1]
      : "";
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1,
    };
    setSearchParams(params);
  };

  // 关闭工单
  const handleClose = (id) => {
    InspectionApi.closeDefectOrder({ id }).then((res) => {
      if (res.status == 0) {
        message.success("关闭成功");
        getListByPages();
      }
    });
  };

  //验收
  const checkaccept = () => {
    setLoadBtn(true);
    form.validateFields().then((values) => {
      if (!values) {
        return;
      }
      InspectionApi.checkAccept({
        id: modifyId,
        checkAcceptDesc: values.checkAcceptDesc,
      }).then((res) => {
        if (res.status == 0) {
          setLoadBtn(false);
          message.success("验收成功");
          setCheckacceptVisible(false);
          form.resetFields();
          getListByPages();
        }
      });
    });
  };

  const cancel = () => {
    setCheckacceptVisible(false);
    form.resetFields();
  };

  const columns1 = [
    {
      title: "缺陷描述",
      dataIndex: "deffectRemark",
      align: "center",
      key: "deffectRemark",
      render: (_t) => toolMouseTip(_t, 6),
    },
    {
      title: "所属厂站",
      dataIndex: "stationName",
      align: "center",
      key: "stationName",
    },
  ];

  const columns = [
    {
      title: "缺陷等级",
      dataIndex: "defectLevelName",
      align: "center",
      key: "defectLevelName",
    },
    {
      title: "缺陷描述",
      dataIndex: "deffectRemark",
      align: "center",
      key: "deffectRemark",
      render: (_t) => toolMouseTip(_t, 6),
    },
    {
      title: "所属厂站",
      dataIndex: "stationName",
      align: "center",
      key: "stationName",
    },
    {
      title: "所属部门",
      dataIndex: "deptName",
      align: "center",
      key: "deptName",
    },
    {
      title: "部门负责人",
      dataIndex: "deptLeaderName",
      align: "center",
      key: "deptLeaderName",
    },
    {
      title: "设备名称",
      dataIndex: "deviceRelevancyName",
      align: "center",
      key: "deviceRelevancyName",
    },
    {
      title: "状态",
      dataIndex: "handleStatus",
      align: "center",
      key: "handleStatus",
      render: (val) => (
        <Tag color={defectStatusColor(val - 0)}>{defectStatus(val - 0)}</Tag>
      ),
    },
    {
      title: "超时状态",
      dataIndex: "timeoutStatus",
      align: "center",
      key: "timeoutStatus",
      render: (_t) =>
        _t == 1 ? (
          <Tag color="#FF3819">超时</Tag>
        ) : (
          <Tag color="#2db7f5">未超时</Tag>
        ),
    },
    {
      title: "安全隐患",
      dataIndex: "safetyPerilFlag",
      align: "center",
      key: "safetyPerilFlag",
      render: (val) => (val ? "是" : "否"),
    },
    {
      title: "发现时间",
      dataIndex: "discoveryTime",
      align: "center",
      key: "discoveryTime",
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
    },
    {
      title: "计划关闭时间",
      dataIndex: "planCloseTime",
      align: "center",
      key: "planCloseTime",
    },
    {
      title: "操作",
      key: "operation",
      width: 500,
      align: "center",
      fixed: "right",
      render: (record) => {
        return (
          <>
            {props.userInfo.btnResources.indexOf("defect:order:relation") !==
              -1 &&
              record.handleStatus !== 3 &&
              record.handleStatus !== 4 && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() =>
                    showRelationDefects(record.stationId, record.id)
                  }
                >
                  关联缺陷单
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("defect:order:checkAccept") !==
              -1 &&
              props.userInfo.btnResources.indexOf("defect:order:info") !== -1 &&
              record.handleStatus == 2 &&
              props.userInfo.realName === record.deptLeaderName && (
                <Button
                  size="small"
                  type="primary"
                  className="success"
                  onClick={() => (
                    setCheckacceptVisible(true),
                    setModifyId(record.id)
                  )}
                  style={{ margin: "0 5px" }}
                >
                  验收
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("instruct:order:add") !== -1 &&
              (record.handleStatus == 0 || record.handleStatus == 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => showInstructAdd(record)}
                  style={{ margin: "0 5px" }}
                >
                  生成指令单
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("work:order:add") !== -1 &&
              (record.handleStatus == 0 || record.handleStatus == 1) && (
                <Button
                  size="small"
                  type="primary"
                  onClick={() => showWorkAdd(record)}
                  style={{ margin: "0 5px" }}
                >
                  生成工单
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("defect:order:close") !== -1 &&
              record.handleStatus !== 3 &&
              record.handleStatus !== 4 && (
                <Button
                  size="small"
                  className="deleteBtn"
                  type="primary"
                  onClick={() => handleClose(record.id)}
                  style={{ margin: "0 5px" }}
                >
                  关闭
                </Button>
              )}
            {props.userInfo.btnResources.indexOf("defect:order:info") !==
              -1 && (
              <Button
                size="small"
                type="primary"
                onClick={() => showInfoDetail(record.id)}
                style={{ margin: "0 5px" }}
              >
                详情
              </Button>
            )}
            {/* {props.userInfo.btnResources.indexOf('defect:order:supplement') !== -1 &&  (record.handleStatus !== 3 && record.handleStatus !== 4) && <Button size='small' type='primary' onClick={ () => (setRecordDefectId(record.id),setRecordModal(true)) }  style={{ margin: '0 5px' }}>补录</Button>} */}
          </>
        );
      },
    },
  ];

  // 详情
  const showInfoDetail = (id) => {
    InspectionApi.defectInfo({ id }).then((res) => {
      if (res.status !== "0") return;
      if (res.data.child && res.data.child.length > 0) {
        let ary = [];
        res.data.child.forEach((item) => {
          if (item.imageUrls && item.imageUrls.length > 0) {
            ary.push(false);
          }
        });
        setDetailSourceImgsVisi(ary);
      }
      setDetail(res.data);
      setDetailModelVisible(true);
    });
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }

    return isJpgOrPng && isLt2M;
  };

  const uploadRecordImg = (info) => {
    const { file } = info;
    if (file.status === "done") {
      const { response: res } = file;
      if (res.status !== "0") return;
      setRecordImageUrls([...recordImageUrls, res.data.url]);
    }
  };

  const removeRecordImg = (info) => {
    const { response: res } = info;
    const url = res.data.url;
    const params = recordImageUrls;
    const index = params.findIndex((item) => item === url);
    params.splice(index, 1);
    setRecordImageUrls([...params]);
  };

  const submiteRecord = () => {
    recordingForm.validateFields().then((values) => {
      if (!values) return;
      const params = {
        ...values,
        imageUrls: recordImageUrls,
        id: recordDefectId,
      };
      InspectionApi.defectOrderSupplement(params).then((res) => {
        if (res.status === "0") {
          message.success("补录成功");
          closeRecordModal();
        }
      });
    });
  };
  const closeRecordModal = () => {
    setRecordModal(false);
    recordingForm.resetFields();
    setRecordImageUrls([]);
  };
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      const ary = [];
      selectedRows.forEach((item) => {
        ary.push(item.id);
      });
      setIds(ary);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  //
  const submiteRetion = () => {
    if (!ids.length) return message.error("请选择要关联的缺陷单");
    InspectionApi.defectRelation({ id: relationId, ids }).then((res) => {
      if (res.status !== "0") return;
      message.success("关联成功");
      setIds([]);
      setRateTionModel(false);
      getListByPages();
    });
  };

  const showRelationDefects = (stationId, relationId) => {
    InspectionApi.defectQuery({
      ...relationSearchParams,
      stationId,
      queryRelation: 1,
      id: relationId,
    }).then((res) => {
      setRelationDefectsLs(res.data.data);
      setRelationTotal(res.data.total);
      setRateTionModel(true);
      setRelationId(relationId);
    });
  };

  // 指令单新增弹窗
  const showInstructAdd = (record) => {
    setInstructAddVisi(true);
    setInstructAddRowParams(record);
  };

  // 工单新增弹窗
  const showWorkAdd = (record) => {
    setWorkAddVisi(true);
    setWorkAddRowParams(record);
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        上传图片
      </div>
    </div>
  );
  return (
    <div className="baseContent boundary">
      <div className="title">
        <div style={{ marginLeft: "24px" }}>
          <div className="search-form">
            <Form
              onFinish={search}
              form={searchForm}
              labelCol={{ span: 9 }}
              wrapperCol={{ span: 15 }}
              layout="inline"
            >
              <Row style={{ width: "100%" }}>
                <Col span={8}>
                  <Form.Item
                    name="stationId"
                    label="厂站"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select
                      placeholder="请选择厂站"
                      onChange={changeSearchStation}
                      allowClear
                    >
                      {stationData.length > 0 &&
                        stationData.map((item) => {
                          return (
                            <Option value={item.value} key={item.value}>
                              {item.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="deviceRelevancyId"
                    label="设备"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Cascader
                      fieldNames={{
                        label: "itemName",
                        value: "id",
                        children: "child",
                      }}
                      options={deviceList}
                      placeholder="请选择设备"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="deptId"
                    label="部门"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Cascader
                      fieldNames={{
                        label: "name",
                        value: "id",
                        children: "children",
                      }}
                      options={deptList}
                      onChange={changeDept}
                      placeholder="请选择部门"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="deptLeaderId"
                    label="部门负责人"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select placeholder={"请选择缺陷等级"} allowClear>
                      {personList &&
                        personList.map((item) => {
                          return (
                            <Option value={item.id} key={item.id}>
                              {item.realName}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="defectLevelId"
                    label="缺陷等级"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select placeholder="请选择缺陷等级" allowClear>
                      {defectslevel.length > 0 &&
                        defectslevel.map((item) => {
                          return (
                            <Option value={item.id} key={item.id}>
                              {item.defectLevelName}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="safetyPerilFlag"
                    label="是否安全隐患"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select placeholder="请选择是否安全隐患" allowClear>
                      <Option value={0}>否</Option>
                      <Option value={1}>是</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="handleStatus"
                    label="状态"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select placeholder="请选择状态" allowClear>
                      <Option value={-1}>未生效</Option>
                      <Option value={0}>待处理</Option>
                      <Option value={1}>处理中</Option>
                      <Option value={2}>完成</Option>
                      <Option value={3}>关闭</Option>
                      <Option value={4}>验收</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="discoveryTime"
                    label="发现时间"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <RangePicker showTime></RangePicker>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="deffectRemark"
                    label="缺陷描述"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input placeholder="请输入缺陷描述" />
                  </Form.Item>
                </Col>
                <Form.Item>
                  <Button
                    className="search-btn"
                    type="primary"
                    htmlType="submit"
                  >
                    搜索
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </div>
        </div>
        <div style={{ textAlign: "right", margin: "10px" }}>
          {props.userInfo.btnResources.indexOf("defect:order:add") !== -1 && (
            <Button
              type="primary"
              onClick={() => {
                setRowParams(null);
                setEditVisible(true);
              }}
            >
              新增
            </Button>
          )}
        </div>
        <div>
          <Table
            className="Table"
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (total) => `共${total}条数据`,
              total: total,
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {checkacceptVisible && (
          <Modal
            title="验收缺陷单"
            width={600}
            open={checkacceptVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={checkaccept}
          >
            <Form form={form} layout="horizontal">
              <Col span={18}>
                <Form.Item
                  label="验收说明"
                  name="checkAcceptDesc"
                  rules={[{ required: true, message: "请输入验收说明!" }]}
                >
                  <Input.TextArea row={4} placeholder={"请输入验收说明"} />
                </Form.Item>
              </Col>
            </Form>
          </Modal>
        )}
        {editVisible && (
          <AddModel
            stationData={stationData}
            visible={editVisible}
            title={editTitle}
            formData={rowParams}
            cancel={(bool) => {
              setEditVisible(false);
              bool && getListByPages();
            }}
          />
        )}
        {/* 详情弹框 */}
        <Modal
          title="缺陷单详情"
          open={detailModelVisible}
          width={800}
          onOk={() => {
            setDetailModelVisible(false);
          }}
          onCancel={() => {
            setDetailModelVisible(false);
          }}
        >
          <div className="defect-detail-td">
            <div className="defect-detail-title">{detail.deffectRemark}</div>
            <div className="defect-detail-status">
              ●&nbsp;&nbsp;{defectStatus(detail.handleStatus)}
            </div>
          </div>
          <div className="defect-detail-bd">
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">厂站名称</div>
              <div className="defect-detail-item-desc">
                {detail.stationName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">创建人</div>
              <div className="defect-detail-item-desc">
                {detail.createByName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">设备</div>
              <div className="defect-detail-item-desc">
                {detail.deviceRelevancyName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">缺陷等级</div>
              <div className="defect-detail-item-desc">
                {detail.defectLevelName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">缺陷建议操作</div>
              <div className="defect-detail-item-desc">
                {detail.defectLevelInstruct}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">所属部门</div>
              <div className="defect-detail-item-desc">{detail.deptName}</div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">部门负责人</div>
              <div className="defect-detail-item-desc">
                {detail.deptLeaderName}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">是否安全隐患</div>
              <div className="defect-detail-item-desc">
                {detail.safetyPerilFlag ? "是" : "否"}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">验收说明</div>
              <div className="defect-detail-item-desc">
                {detail.checkAcceptDesc ? detail.checkAcceptDesc : "-"}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">创建时间</div>
              <div className="defect-detail-item-desc">{detail.createAt}</div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">计划关闭时间</div>
              <div className="defect-detail-item-desc">
                {detail.planCloseTime}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">发现时间</div>
              <div className="defect-detail-item-desc">
                {detail.discoveryTime}
              </div>
            </div>
            <div className="defect-detail-bd-item">
              <div className="defect-detail-item-lable">超时状态</div>
              <div className="defect-detail-item-desc">
                {detail.timeoutStatus == 1 ? "超时" : "未超时"}
              </div>
            </div>
            <div className="defect-detail-bd-img">
              <div className="defect-detail-item-lable">图片展示</div>
              {detail.imageUrls && detail.imageUrls.length > 0 ? (
                <div className="defect-detail-item-imglist">
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={200}
                    src={detail.imageUrls[0]}
                    onClick={() => setDefectDetailImgVisibel(true)}
                  />

                  <div style={{ display: "none" }}>
                    <Image.PreviewGroup
                      preview={{
                        visible: defectDetailImgVisibel,
                        onVisibleChange: (vis) =>
                          setDefectDetailImgVisibel(vis),
                      }}
                    >
                      {detail.imageUrls.map((item, index) => {
                        return <Image src={item} key={index} />;
                      })}
                    </Image.PreviewGroup>
                  </div>
                </div>
              ) : (
                <Empty description="暂无图片" />
              )}
            </div>
          </div>
          <div className="defect-details-list-item">
            <div className="defect-details-list-item-td">
              <div className="defect-detail-item-lable">关联缺陷单</div>
            </div>
            {detail.child &&
              detail.child.length > 0 &&
              detail.child.map((item, index) => {
                return (
                  <div key={item.id}>
                    <div className="defect-details-list-item-bd">
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          缺陷描述
                        </div>
                        <div className="defect-details-item-content-text">
                          {toolMouseTip(item.deffectRemark, 6)}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          是否安全隐患
                        </div>
                        <div className="defect-details-item-content-text">
                          {item.safetyPerilFlag ? "是" : "否"}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          所属部门
                        </div>
                        <div className="defect-details-item-content-text">
                          {item.deptName}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          部门负责人
                        </div>
                        <div className="defect-details-item-content-text">
                          {item.deptLeaderName}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          发现时间
                        </div>
                        <div className="defect-details-item-content-text">
                          {item.discoveryTime}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          计划关闭时间
                        </div>
                        <div className="defect-details-item-content-text">
                          {item.planCloseTime}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          图片
                        </div>
                        <div className="defect-details-item-content-text">
                          {item.imageUrls && item.imageUrls.length > 0 ? (
                            <div className="defect-detail-item-imglist">
                              <Image
                                preview={{
                                  visible: false,
                                }}
                                width={100}
                                src={item.imageUrls[0]}
                                onClick={() => {
                                  let p = detailSourceImgsVisi;
                                  p[index] = true;
                                  setDetailSourceImgsVisi([...p]);
                                }}
                              />

                              <div style={{ display: "none" }}>
                                <Image.PreviewGroup
                                  preview={{
                                    visible: detailSourceImgsVisi[index],
                                    onVisibleChange: (vis) => {
                                      let p = detailSourceImgsVisi;
                                      p[index] = vis;
                                      setDetailSourceImgsVisi([...p]);
                                    },
                                  }}
                                >
                                  {item.imageUrls.map((item, index) => {
                                    return <Image src={item} key={index} />;
                                  })}
                                </Image.PreviewGroup>
                              </div>
                            </div>
                          ) : (
                            "暂无图片"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="defect-details-list">
            <div className="defect-details-list-item">
              <div className="defect-details-list-item-td">
                <div className="defect-detail-item-lable">关联指令单</div>
              </div>
              {detail.instructOrders &&
                detail.instructOrders.length > 0 &&
                detail.instructOrders.map((item) => {
                  return (
                    <div className="defect-details-list-item-bd" key={item.id}>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          指令标题
                        </div>
                        <div className="defect-details-item-content-text">
                          {toolMouseTip(item.instructTitle, 6)}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          开始时间
                        </div>
                        <div className="defect-details-item-content-text">
                          {moment(item.beginTime).format("YYYY-MM-DD HH:mm:ss")}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          结束时间
                        </div>
                        <div className="defect-details-item-content-text">
                          {moment(item.endTime).format("YYYY-MM-DD HH:mm:ss")}
                        </div>
                      </div>
                      <div className="defect-details-item-content">
                        <div className="defect-details-item-content-label">
                          状态
                        </div>
                        <div className="defect-details-item-content-text">
                          {instructStatus(item.handleStatus)}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="defect-details-list-item">
              <div className="defect-details-list-item-td">
                <div className="defect-detail-item-lable">关联工单</div>
              </div>
              {detail.workOrders &&
                detail.workOrders.length > 0 &&
                detail.workOrders.map((item) => {
                  return (
                    <div key={item.id}>
                      <div className="defect-details-list-item-bd">
                        <div className="defect-details-item-content">
                          <div className="defect-details-item-content-label">
                            工单标题
                          </div>
                          <div className="defect-details-item-content-text">
                            {toolMouseTip(item.workOrderTitle, 6)}
                          </div>
                        </div>
                        <div className="defect-details-item-content">
                          <div className="defect-details-item-content-label">
                            开始时间
                          </div>
                          <div className="defect-details-item-content-text">
                            {item.beginTime}
                          </div>
                        </div>
                        <div className="defect-details-item-content">
                          <div className="defect-details-item-content-label">
                            结束时间
                          </div>
                          <div className="defect-details-item-content-text">
                            {item.endTime}
                          </div>
                        </div>
                        <div className="defect-details-item-content">
                          <div className="defect-details-item-content-label">
                            状态
                          </div>
                          <div className="defect-details-item-content-text error">
                            <span
                              style={{ color: colorStatus[item.status - 0] }}
                            >
                              {StatusData[item.status - 0]}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </Modal>
        {/* 关联缺陷单弹框 */}
        <Modal
          width={800}
          title="关联缺陷单"
          open={rateTionModel}
          onCancel={() => (setRateTionModel(false), setIds([]))}
          onOk={submiteRetion}
        >
          <Table
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
            pagination={{
              current: relationSearchParams.pageNum,
              pageSize: relationSearchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: (relationTotal) => `共${relationTotal}条数据`,
              total: relationTotal,
            }}
            onChange={handleTableChange1}
            rowKey={(record) => record.id}
            columns={columns1}
            dataSource={relationDefectsLs}
          />
        </Modal>
        {/* 补录 */}
        {recordModal && (
          <Modal
            title="补录"
            open={recordModal}
            onCancel={closeRecordModal}
            onOk={submiteRecord}
          >
            <Form layout="horizontal" form={recordingForm}>
              <Form.Item
                label="缺陷描述"
                name="deffectRemark"
                rules={[{ required: true, message: "请输入缺陷描述!" }]}
              >
                <TextArea rows={3} placeholder="请输入缺陷描述" />
              </Form.Item>
              <Form.Item label="图片">
                <Upload
                  name="file"
                  action={window.globalConfig.UPLOADER}
                  headers={{ authorization: sessionStorage.getItem("token") }}
                  beforeUpload={(e) => beforeUpload(e)}
                  onChange={(e) => uploadRecordImg(e)}
                  onRemove={(e) => removeRecordImg(e)}
                >
                  <Button icon={<UploadOutlined />}>上传图片</Button>
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
        )}
        {/* /补录 */}
      </div>
      {instructAddVisi && (
        <InstructAdd
          stationData={stationData}
          visible={instructAddVisi}
          title="新增指令单"
          rowData={instructAddRowParams}
          cancel={(bool) => {
            setInstructAddVisi(false);
            bool && getListByPages();
          }}
        />
      )}
      {workAddVisi && (
        <WorkAdd
          stationData={stationData}
          visible={workAddVisi}
          title="新增工单"
          rowData={workAddRowParams}
          cancel={(bool) => {
            setWorkAddVisi(false);
            bool && getListByPages();
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(OrderCom);
